<div class="user-tooltip">
  <div class="user-tooltip-inner">
    <div class="user-tooltip-inner-1">
      <span class="user-tooltip-caret"></span>
      <a uiSref="profile.about" [uiParams]="{ profileId: user?.slug }" aria-hidden="true" tabindex="-1">
        <ut-avatar-badges [user]="user" size="larger"></ut-avatar-badges>
      </a>
      @if (user?.follow_stats?.follows_current_user) {
        <p class="user-tooltip-info">
          <i class="icon-check"></i> FOLLOWS YOU
        </p>
      }
      <p>
        <span>{{user?.points | number:'1.0-0'}}</span>
        &ngsp;<small>uPOINTS</small>
      </p>
    </div>
    <div class="user-tooltip-inner-2">
      <button id="closeUserTooltipBtn"
        autofocus
        type="button"
        class="close"
        (click)="onCloseClick($event)"
        (keypress)="onCloseKeyPress($event)"
        (focus)="onCloseFocus($event)"
        (blur)="onCloseBlur($event)"
        (mouseenter)="onCloseFocus($event)"
        (mouseleave)="onCloseBlur($event)"
        aria-label="Close"
        style="color: white; opacity: 0.8;">
        <i class="icon-cancel"></i>
      </button>
      <div class="user-tooltip-inner-2-content">
        <p class="tooltip-user-name" [attr.aria-label]="user?.name">{{user?.name}}</p>
        @if (user?.user_title) {
          <p>{{user?.user_title}}</p>
        }
        <p class="user-slug">
          <a uiSref="profile.about" [uiParams]="{ profileId: user?.slug }"
            [attr.aria-label]="user?.name + ', @' + user?.slug + ', Community Profile'">
            &#64;{{user?.slug}}
          </a>
        </p>
        @if (!userLocation) {
          <p>{{userRole}}</p>
        }
        @if (userLocation) {
          <p>
            <i class="icon-location"></i>
            <span>{{userLocation}}</span>
          </p>
        }
        @if (user?.current_user_permissions?.follow) {
          <ut-community-follow-btn
            [user]="user"
            >
          </ut-community-follow-btn>
        }
      </div>
    </div>
  </div>
</div>
